import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import 'contents/assets/scss/page/mypage.scss';
import Paging from '../../../component/Inc/Paging';
import Tab from '../../../component/Inc/Tab';
function Attendance() {
  const navigate = useNavigate();
  const [isOrderActive2, setIsOrderActive2] = useState(false);
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '담당학생 전체', value: 0},
    {title: '당일 출석부', value: 1},
    {title: '출석 미체크', value: 2},
    {title: '결석', value: 3},
    {title: '사전통화 미등록', value: 4}
  ];
  return (
    <main className="com_container com_attendance">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu12_2">출석부</h2>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              <span className="com_check_box">
                <input type="checkbox" name="chk" id="chk00" className="com_chk" />
                <label htmlFor="chk00">내 출석부</label>
              </span>
              <section className="com_board_search end">
                <div className="com_btn_wrap">
                  <button className="com_btn line gray s active">오늘</button>
                  <button className="com_btn line gray s">주간</button>
                  <button className="com_btn line gray s">월간</button>
                </div>
                <div className="date_wrap">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <span className="divider"> ~ </span>
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <button className="com_btn gray s">조회</button>
                </div>
                <span className="bar" />
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <p className="com_red_txt">* 수업 시작 24시간 전부터 수업 시작 전까지만 변경 신청 가능, 지연 신청 시 포인트 차감 됩니다.</p>
            <table className="com_board_list">
              <colgroup>
                <col width="5%" />
                <col width="9%" />
                <col width="9%" />
                <col width="6.5%" />
                <col width="10%" />
                <col width="8%" />
                <col width="5%" />
                <col width="6.5%" />
                <col width="6%" />
                <col width="6%" />
                <col width="13%" />
                <col width="10%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>수업일시</th>
                  <th>사전통화</th>
                  <th>학생명</th>
                  <th>전화번호</th>
                  <th>수업장소</th>
                  <th>수업상세</th>
                  <th>담임명</th>
                  <th>회차 / T</th>
                  <th>진행 회차</th>
                  <th>출석 현황</th>
                  <th>
                    다음 수업일{' '}
                    <button
                      onClick={() => {
                        setIsOrderActive2(!isOrderActive2);
                      }}
                      className={`arrow ${isOrderActive2 ? `active` : ``}`}
                    />
                  </th>
                  <th>출석</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>12</td>
                  <td className="td_date">2023, 05, 11 12:30</td>
                  <td>
                    <button className="btn_link blue">통화 등록</button>
                  </td>
                  <td>
                    <button onClick={() => navigate('/Mypage/Attendance/Detail')} className="name btn_link">
                      김길동111
                    </button>
                  </td>
                  <td>
                    <div className="contact_item">학 : 010-1234-1234</div>
                    <div className="contact_item">모 : 010-1324-3212</div>
                    <div className="contact_item">부 : 010-1234-1234</div>
                  </td>
                  <td>경기도 수원시</td>
                  <td>수학영역</td>
                  <td>
                    <button className="name btn_link">김담임103</button>
                  </td>
                  <td>16 / 2T</td>
                  <td className="td_point">첫수업</td>
                  <td>
                    <div className="status_class">
                      <span className="item">출석5</span>
                      <span className="item">결석2조퇴5</span>
                      <span className="item">연기 5</span>
                    </div>
                  </td>
                  <td>2023, 05, 11 12:30</td>
                  <td>
                    <button className="com_btn gray xxs">출석</button>
                  </td>
                </tr>
                <tr>
                  <td>11</td>
                  <td className="td_date">2023, 05, 11 12:30</td>
                  <td>
                    <button className="btn_link">2023, 05, 12 12 : 30</button>
                  </td>
                  <td>
                    <button onClick={() => navigate('/Mypage/Attendance/Detail')} className="name btn_link">
                      김길동111
                    </button>
                  </td>
                  <td>
                    <div className="contact_item">학 : 010-1234-1234</div>
                    <div className="contact_item">모 : 010-1324-3212</div>
                    <div className="contact_item">부 : 010-1234-1234</div>
                  </td>
                  <td>경기도 수원시</td>
                  <td>수학영역</td>
                  <td>
                    <button className="name btn_link">김담임103</button>
                  </td>
                  <td>16 / 2T</td>
                  <td>10</td>
                  <td>
                    <div className="status_class">
                      <span className="item">출석5</span>
                      <span className="item">결석2조퇴5</span>
                      <span className="item">연기 5</span>
                    </div>
                  </td>
                  <td>2023, 05, 11 12:30</td>
                  <td className="td_point">결석</td>
                </tr>
                {[1, 2, 3, 4, 5, 6, 7, 8].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{10 - idx}</td>
                      <td className="td_date">2023, 05, 11 12:30</td>
                      <td>
                        <button className="btn_link">2023, 05, 12 12 : 30</button>
                      </td>
                      <td>
                        <button onClick={() => navigate('/Mypage/Attendance/Detail')} className="name btn_link">
                          김길동111
                        </button>
                      </td>
                      <td>
                        <div className="contact_item">학 : 010-1234-1234</div>
                        <div className="contact_item">모 : 010-1324-3212</div>
                        <div className="contact_item">부 : 010-1234-1234</div>
                      </td>
                      <td>경기도 수원시</td>
                      <td>수학영역</td>
                      <td>
                        <button className="name btn_link">김담임103</button>
                      </td>
                      <td>16 / 2T</td>
                      <td className="td_point">첫수업</td>
                      <td>
                        <div className="status_class">
                          <span className="item">출석5</span>
                          <span className="item">결석2조퇴5</span>
                          <span className="item">연기 5</span>
                        </div>
                      </td>
                      <td>2023, 05, 11 12:30</td>
                      <td className="td_point">조퇴</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Paging />
          </section>
        </section>
      </div>
    </main>
  );
}

export default Attendance;
